module.exports = __webpack_public_path__ + "src/assets/flag_Red.svg";